module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"holder":"Владелец аккаунта","settings":"Настройки","changePass":"Изменение пароля"}}')
  delete Component.options._Ctor
}
